import React from 'react'
import { Provider } from './PreCheckedProviders.types'

interface DescriptionProps {
  /** Category name description */
  description?: string
  /** Whether it is professional or facility services */
  isProfessional: boolean
  /** List of facility providers to show */
  facilityProviders?: Provider[]
  /** List of individual providers to show */
  professionalProviders?: Provider[]
  /** Type of page the description is on */
  type?:
    | 'careDetail'
    | 'careSearch'
    | 'episodeOfCare'
    | 'publicCareDetail'
    | 'requestForm'
}

// Relocated styles from Description.styles.js
const getStyles = ({ tag }: { tag?: string }) => {
  switch (tag) {
    case 'episodeOfCare':
      return `sh-body-sm mb-0 text-left`

    case 'careDetail':
      return `sh-body-sm mb-2.5 text-left`

    case 'careSearch':
      return `sh-body mb-2.5 text-left`

    default:
      return ''
  }
}

/** Subtext that goes below the title of a prechecked provider title */
export const Description: React.FC<DescriptionProps> = ({
  description = '',
  isProfessional,
  facilityProviders = [],
  professionalProviders = [],
  type = '',
}) => {
  // ----------- Description Variables -----------
  const pluralText =
    professionalProviders?.length > 1 || facilityProviders?.length > 1
      ? 'these'
      : 'this'
  const pluralProfessionalProviderText =
    professionalProviders?.length > 1 ? 'providers' : 'provider'
  const pluralFacilityProviderText =
    facilityProviders?.length > 1 ? 'facilities' : 'facility'
  const precheckedProviderText = isProfessional
    ? pluralProfessionalProviderText
    : pluralFacilityProviderText

  // ----------- Description Text -----------

  /* the care detail and EOC descriptions are the same */
  const detailAndEpisodeDescription = `You won't pay anything when using 
  ${pluralText} pre-checked ${precheckedProviderText} for this service if 
  your deductible has been met or doesn't apply. If the deductible applies, 
  you will be responsible for the entire amount of the provider's charge.`

  const careDetailText = (
    <p className={getStyles({ tag: type })} data-testid="info_description">
      {detailAndEpisodeDescription}
    </p>
  )
  const careSearchText = (
    <p className={getStyles({ tag: type })} data-testid="info_description">
      {`You won't pay anything for ${description} services at ${pluralText} 
      pre-checked ${pluralProfessionalProviderText} if your deductible has 
      been met or doesn't apply. If the deductible applies, you'll be responsible 
      for the entire amount of the provider's charge.`}
    </p>
  )

  if (type === 'careDetail' || type === 'publicCareDetail')
    return careDetailText
  if (type === 'careSearch') return careSearchText

  return null
}
